import type { ChangeEvent } from 'react'
import type { OnboardingScenarioProps } from './types'

export function useBreakUpIntroduction({ payload, onChange: change }: Pick<OnboardingScenarioProps, 'payload' | 'onChange'>) {
  const name = typeof payload.custom?.name === 'string' ? payload.custom.name : ''
  const communicationStyle = payload.communicationStyle ?? 'analytic'
  const changeName = (event: ChangeEvent<HTMLInputElement>) => change({ ...payload, custom: { ...payload.custom, name: event.target.value } })
  const changeStyle = (event: ChangeEvent<HTMLInputElement>) => change({ ...payload, communicationStyle: event.target.value })
  return { name, communicationStyle, changeName, changeStyle }
}
